import React, { useEffect, useState } from "react";
import pptxgen from "pptxgenjs";
import { BlobServiceClient } from "@azure/storage-blob";
import { RiDownload2Fill } from "react-icons/ri";

import {
  generateTextDataUsingLLM,
  getCurrentStatusOfPPT,
} from "../utils/function";
import {
  generateTextAndTableSlideV1,
  generateTextAndTableSlideV2,
  generateTextAndTableSlideV4,
  generateTextAndTableSlideV9,
  generateTextAndTableSlideV19,
  generateTextAndTableSlideV14,
  generateTextAndTableSlideV0,
} from "../utils/helper";
import {
  DEFAULT_CHART_OBJECT,
  DEFAULT_IMAGE_OBJECT,
  DEFAULT_TABLE_OBJECT,
  DEFAULT_TEXT_OBJECT,
  defaultSlideData,
  LAYOUT_OPTIONS,
} from "../data";
import {
  containerName,
  PPT2IMG_BACKEND_URL,
  sasToken,
  storageAccountName,
  templates,
} from "../data/constant";
import toast from "../components/ui/Toast";
import FontSelector from "../components/PPT/FontSelector";

import SlideControlsTest from "../components/PPT/SlideControlsTest";
import ImageViewer from "../components/PPT/ImageViewer";
import Button from "../components/ui/Button";
import InsertImage from "../components/insert/InsertImage";
import InsertChart from "../components/insert/InsertChart";
import InsertTable from "../components/insert/InsertTable";
import MoveMedia from "../components/insert/MoveMedia";
import EditSlide from "../components/insert/EditSlide";
import PPTInputUI from "./PPT/PPTInputUI";
import EditFirstSlide from "./insert/EditFirstSlide";
import EditGenericSlide from "./insert/EditGenericSlide";
import TemplateDropdown from "./PPT/TemplateDropdown";

function PPTGenerator() {
  let pptx = new pptxgen();

  // Core states
  const [pdfText, setPdfText] = useState("");
  const [pptName, setPptName] = useState("");
  const [imageArray, setImageArray] = useState([]);
  const [textView, setTextView] = useState(true);
  const [isGenerated, setIsGenerated] = useState(false);
  const [isLoading, setIsLoading] = useState("");
  const [slidesConfig, setSlidesConfig] = useState([]);
  const [activeSlide, setActiveSlide] = useState(1);
  const [latestBlob, setLatestBlob] = useState("");
  const [pdfUrl, setPdfUrl] = useState();
  const [selectedTemplate, setSelectedTemplate] = useState({
    id: 1,
    name: "Template 1",
  });

  // Sidebar states
  const [isInsertChartOpen, setIsInsertChartOpen] = useState(false);
  const [isInsertTableOpen, setIsInsertTableOpen] = useState(false);
  const [isInsertImageOpen, setIsInsertImageOpen] = useState(false);
  const [isMoveMediaOpen, setIsMoveMediaOpen] = useState(false);
  const [isEditSlideOpen, setIsEditSlideOpen] = useState(false);
  const [selectedFont, setSelectedFont] = useState();
  const [isEditFirstSlideOpen, setIsEditFirstSlideOpen] = useState(false);

  // Get blobs from Azure container
  const getBlobsInContainer = async (containerClient) => {
    const returnedBlobUrls = [];
    for await (const blob of containerClient.listBlobsFlat()) {
      returnedBlobUrls.push(
        `https://${storageAccountName}.blob.core.windows.net/${containerName}/${blob.name}`
      );
    }
    return returnedBlobUrls;
  };

  // Upload file to Azure blob storage
  async function uploadFileToBlob2(fileBlob, fileName) {
    setIsLoading("Generating best layouts...");
    try {
      const blobServiceClient = new BlobServiceClient(
        `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`
      );
      const containerClient = blobServiceClient.getContainerClient(containerName);
      const blockBlobClient = containerClient.getBlockBlobClient(fileName);

      await blockBlobClient.uploadBrowserData(fileBlob, {
        blobHTTPHeaders: { blobContentType: fileBlob.type },
      });

      const fileUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${fileName}`;
      convertPptxToPdf(fileUrl);
      return fileUrl;
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  }

  // Handle template selection
  const handleSelectTemplate = (template) => {
    setSelectedTemplate(template);
    localStorage.setItem("PPT_BG", template.bgColor.split("#")[1]);
    localStorage.setItem("PPT_BG_TEMPLATE_ID", template.id - 1);
  };

  useEffect(() => {
    handleSelectTemplate(templates[0]);
  }, []);

  // Handle media movement
  const onMoveMediaDone = (updatedConfigs) => {
    setIsMoveMediaOpen(false);
    setSlidesConfig(updatedConfigs);
    layoutGenerator(pptx, updatedConfigs,selectedFont?.value);
  };

  function onReplaceTable(updatedConfigs){
    // layoutGenerator
  }

  // Add chart to slide
  async function onAddChart(data) {
    const {
      extractedData,
      chartType,
      title,
      xAxisLabel,
      yAxisLabel,
      imageUrl,
      isGeneratedByContent,
    } = data;
    const { prevConfigs, lastSlide, lastSlideItems, isTextAvailable } =
      getCurrentStatusOfPPT(slidesConfig, activeSlide);

    if (isTextAvailable && lastSlideItems.length === 1) {
      lastSlideItems.push({
        ...DEFAULT_CHART_OBJECT,
        data: extractedData,
        chartType,
        chartTitle: title,
        xAxisLabel,
        yAxisLabel,
        imageUrl,
        isGeneratedByContent: isGeneratedByContent,
      });
      lastSlide.layout = "v2";
      setSlidesConfig(prevConfigs);
      layoutGenerator(pptx, prevConfigs,selectedFont?.value);
      return;
    }

    if (isTextAvailable && lastSlideItems.length === 2) {
      // Todo: Write logic what needs to be moved to next slide  if chart is generated  by the  content 
      // replacement of existing chart/table
      // if not generated by then move that out
      lastSlideItems.push({
        ...DEFAULT_CHART_OBJECT,
        data: extractedData,
        chartType,
        chartTitle: title,
        xAxisLabel,
        yAxisLabel,
        imageUrl,
        isGeneratedByContent: isGeneratedByContent,
      });
      lastSlide.layout = "v4";
      setSlidesConfig(prevConfigs);
      layoutGenerator(pptx, prevConfigs,selectedFont?.value);
      return;
    }

    if (isTextAvailable && lastSlideItems.length === 3) {
      onAddSlide({
        type: "chart",
        data:extractedData,
        title,
        chartType,
        xAxisLabel,
        yAxisLabel,
        imageUrl,
        isGeneratedByContent: isGeneratedByContent,
      });
      return;
    }

    if (!isTextAvailable && lastSlideItems.length === 1) {
      addSecondMediaOnExistingSlide({
        type: "chart",
       data: extractedData,
        title,
        chartType,
        xAxisLabel,
        yAxisLabel,
        imageUrl,
        isGeneratedByContent: isGeneratedByContent,
      });
      return;
    }

    if (!isTextAvailable && lastSlideItems.length === 2) {
      onAddSlide({
        type: "chart",
        extractedData,
        data:extractedData,
        title,
        chartType,
        xAxisLabel,
        yAxisLabel,
        imageUrl,
        isGeneratedByContent: isGeneratedByContent,
      });
      return;
    }

    if (!isTextAvailable && lastSlideItems.length === 0) {
      addSingleMediaOnExistingBlankSlide({
        type: "chart",
        data: extractedData,
        title,
        chartType,
        xAxisLabel,
        imageUrl,
        yAxisLabel,
        isGeneratedByContent: isGeneratedByContent,
      });
      return;
    }
  }

  // Add table to slide
  async function onAddTable({
    extractedData,
    tableTitle,
    imageUrl,
    isGeneratedByContent,
  }) {
    const { prevConfigs, lastSlide, lastSlideItems, isTextAvailable } =
      getCurrentStatusOfPPT(slidesConfig, activeSlide);

    if (isTextAvailable && lastSlideItems.length === 1) {
      lastSlideItems.push({
        ...DEFAULT_TABLE_OBJECT,
        data: extractedData,
        tableTitle,
        imageUrl,
        isGeneratedByContent: isGeneratedByContent,
      });
      lastSlide.layout = "v2";
      setSlidesConfig(prevConfigs);
      layoutGenerator(pptx, prevConfigs,selectedFont?.value);
      return;
    }

    if (isTextAvailable && lastSlideItems.length === 2) {
      lastSlideItems.push({
        ...DEFAULT_TABLE_OBJECT,
        data: extractedData,
        tableTitle,
        imageUrl,
        isGeneratedByContent: isGeneratedByContent,
      });
      lastSlide.layout = "v4";
      setSlidesConfig(prevConfigs);
      layoutGenerator(pptx, prevConfigs,selectedFont?.value);
      return;
    }

    if (isTextAvailable && lastSlideItems.length === 3) {
      onAddSlide({
        type: "table",
        data: extractedData,
        extractedData,
        tableTitle,
        imageUrl,
        isGeneratedByContent,
      });
      return;
    }

    if (!isTextAvailable && lastSlideItems.length === 1) {
      addSecondMediaOnExistingSlide({
        type: "table",
        extractedData,
        data: extractedData,
        tableTitle,
        imageUrl,
        isGeneratedByContent: isGeneratedByContent,
      });
      return;
    }

    if (!isTextAvailable && lastSlideItems.length === 2) {
      onAddSlide({
        type: "table",
        extractedData,
        data: extractedData,
        tableTitle,
        imageUrl,
        isGeneratedByContent: isGeneratedByContent,
      });
      return;
    }

    if (!isTextAvailable && lastSlideItems.length === 0) {
      addSingleMediaOnExistingBlankSlide({
        type: "table",
        extractedData,
        data: extractedData,
        tableTitle,
        imageUrl,
        isGeneratedByContent: isGeneratedByContent,
      });
      return;
    }
  }

  // Add image to slide
  function onAddImage(url) {
    const { prevConfigs, lastSlide, lastSlideItems, isTextAvailable } =
      getCurrentStatusOfPPT(slidesConfig, activeSlide);

    if (isTextAvailable && lastSlideItems.length === 1) {
      lastSlideItems.push({
        ...DEFAULT_IMAGE_OBJECT,
        path: url,
      });
      lastSlide.layout = "v2";
      setSlidesConfig(prevConfigs);
      layoutGenerator(pptx, prevConfigs,selectedFont?.value);
      return;
    }

    if (isTextAvailable && lastSlideItems.length === 2) {
      lastSlideItems.push({
        ...DEFAULT_IMAGE_OBJECT,
        path: url,
      });
      lastSlide.layout = "v4";
      setSlidesConfig(prevConfigs);
      layoutGenerator(pptx, prevConfigs,selectedFont?.value);
      return; 
    }

    if (isTextAvailable && lastSlideItems.length === 3) {
      onAddSlide({ type: "image", url, imageUrl: url });
      return;
    }

    if (!isTextAvailable && lastSlideItems.length === 1) {
      addSecondMediaOnExistingSlide({ type: "image", imageUrl: url });
      return;
    }

    if (!isTextAvailable && lastSlideItems.length === 2) {
      onAddSlide({ type: "image", url, imageUrl: url });
      return;
    }

    if (!isTextAvailable && lastSlideItems.length === 0) {
      addSingleMediaOnExistingBlankSlide({ type: "image", imageUrl: url });
      return;
    }
  }

  // Add new slide
  function onAddSlide(dataObj = {}) {
    const {
      type = null,
      data = null,
      title = null,
      chartType = null,
      xAxisLabel = null,
      yAxisLabel = null,
      imageUrl = null,
      isGeneratedByContent = null,
    } = dataObj;
    const prevSlides = [...slidesConfig];
    const newSlideConfig = {
      ...defaultSlideData,
      title: "",
      layout: "v1",
      slideId: slidesConfig.length + 1,
    };

    if (dataObj && type === "chart") {
      newSlideConfig.slideDataArray = [
        {
          ...DEFAULT_CHART_OBJECT,
          data,
          chartType,
          chartTitle: title,
          xAxisLabel,
          yAxisLabel,
          imageUrl,
          isGeneratedByContent: isGeneratedByContent,
        },
      ];
    }
    if (dataObj && type === "image") {
      newSlideConfig.slideDataArray = [
        {
          ...DEFAULT_IMAGE_OBJECT,
          path: data || imageUrl,
          imageUrl,
        },
      ];
    }
    if (dataObj && type === "table") {
      newSlideConfig.slideDataArray = [
        {
          ...DEFAULT_TABLE_OBJECT,
          data,
          tableTitle: title,
          imageUrl,
          isGeneratedByContent: isGeneratedByContent,
        },
      ];
    }

    prevSlides.splice(activeSlide, 0, newSlideConfig);
    setSlidesConfig(prevSlides);
    layoutGenerator(pptx, prevSlides,selectedFont?.value);
  }

  // Add media to blank slide
  function addSingleMediaOnExistingBlankSlide(dataObj) {
    const {
      type,
      data,
      imageUrl,
      title,
      chartType,
      xAxisLabel,
      yAxisLabel,
      isGeneratedByContent,
    } = dataObj;
    const existingSlide = { ...slidesConfig[activeSlide - 1] };

    if (type === "chart") {
      existingSlide.slideDataArray = [
        {
          ...DEFAULT_CHART_OBJECT,
          data,
          chartType,
          chartTitle: title,
          xAxisLabel,
          yAxisLabel,
          imageUrl,
          isGeneratedByContent: isGeneratedByContent,
        },
      ];
    }
    if (type === "image") {
      existingSlide.slideDataArray = [
        {
          ...DEFAULT_IMAGE_OBJECT,
          path: imageUrl,
        },
      ];
    }
    if (type === "table") {
      existingSlide.slideDataArray = [
        {
          ...DEFAULT_TABLE_OBJECT,
          data,
          tableTitle: title,
          imageUrl,
          isGeneratedByContent: isGeneratedByContent,
        },
      ];
    }

    const prevSlides = [...slidesConfig];
    prevSlides[activeSlide - 1] = existingSlide;
    setSlidesConfig(prevSlides);
    layoutGenerator(pptx, prevSlides,selectedFont?.value);
  }
  function onTemplateChange(template) {
    console.info("Template changed:", template);
    // this will update Local storage and selected template
    handleSelectTemplate(template);
    // this will update the pptx with the new template
    layoutGenerator(pptx, slidesConfig,selectedFont?.value);
  }
  function onFontChange(font) {
    console.info("Font changed:", font);
    setSelectedFont(font);
    pptx.default = {
      fontSize: 12,
      fontFace: font.value,
    };
    localStorage.setItem("PPT_FONT", font.value);
    // this will update Local storage and selected font
    // handleSelectFont(font);
    layoutGenerator(pptx, slidesConfig,font.value);
  }
  // Add second media to existing slide
  function addSecondMediaOnExistingSlide({
    type,
    data,
    title,
    chartType,
    xAxisLabel,
    imageUrl,
    yAxisLabel,
    isGeneratedByContent,
  }) {
    const existingSlide = { ...slidesConfig[activeSlide - 1] };
    existingSlide.layout = "v9";

    if (type === "chart") {
      existingSlide.slideDataArray.push({
        ...DEFAULT_CHART_OBJECT,
        data,
        chartType,
        chartTitle: title,
        xAxisLabel,
        yAxisLabel,
        isGeneratedByContent: isGeneratedByContent,
      });
    }
    if (type === "image") {
      existingSlide.slideDataArray.push({
        ...DEFAULT_IMAGE_OBJECT,
        path: imageUrl,
      });
    }
    if (type === "table") {
      existingSlide.slideDataArray.push({
        ...DEFAULT_TABLE_OBJECT,
        data,
        tableTitle: title,
        isGeneratedByContent: isGeneratedByContent,
        options: { ...LAYOUT_OPTIONS.LAYOUT_9_MEDIA_FULL_OPTIONS_TABLE },
      });
    }

    const prevSlides = [...slidesConfig];
    prevSlides[activeSlide - 1] = existingSlide;
    setSlidesConfig(prevSlides);
    layoutGenerator(pptx, prevSlides,selectedFont?.value);
  }

  // Generate layout
  function layoutGenerator(pptx, slidesArray,font) {
    setIsLoading("Performing Initial steps...");
 

    slidesArray.forEach((slideData) => {
      switch (slideData.layout) {
        case "v0":
          generateTextAndTableSlideV0(pptx, slideData,font);
          break;
          // only text/media
        case "v1":
          generateTextAndTableSlideV1(pptx, slideData,font);
          break;
          // text +media
        case "v2":
          generateTextAndTableSlideV2(pptx, slideData,font);
          break;
          // text + media +media
        case "v4":
          generateTextAndTableSlideV4(pptx, slideData,font);
          break;
          // text +media +media  ( Landscape)
        case "v14":
          generateTextAndTableSlideV14(pptx, slideData,font);
          break;
          // text +media +media  ( Portrait)
        case "v9":
          generateTextAndTableSlideV9(pptx, slideData,font);
          break;
          // media +media   ( Landscape)
        case "v19":
          // media +media   ( Portrait)
          generateTextAndTableSlideV19(pptx, slideData,font);
          break;
        
        default:
          break;
      }
    });

    pptx.write("base64").then(async (base64String) => {
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const pptBlob = new Blob([byteArray], {
        type: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      });

      const res = await uploadFileToBlob2(pptBlob, `codemonk.pptx`);
      setLatestBlob(res);

      const blobService = new BlobServiceClient(
        `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`
      );
      const containerClient = blobService.getContainerClient(containerName);
      return getBlobsInContainer(containerClient);
    });
  }

  // Convert PPTX to PDF
  async function convertPptxToPdf(pptxUrl) {
    setIsLoading("Performing core steps...");
    try {
      const response = await fetch(PPT2IMG_BACKEND_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ pptxUrl }),
      });

      if (!response.ok) {
        setIsLoading(false)
        toast.show({
          heading: "Failed to generate slides",
          variant: "error",
        });
        throw new Error("Failed to convert PPTX to PDF");
      }
      setIsLoading("Almost there...");

      const data = await response.json();
      setImageArray(data?.uploadedUrls);
      setPdfUrl(data?.pdfUrl);
      setTimeout(() => {
        setIsLoading(false);
      }, 1500);
      setIsGenerated(true);
      return data.pdfUrl;
    } catch (error) {
      toast.show({
        heading: "Failed to convert load slides",
        variant: "error",
      });
      console.error("Error:", error);
    }
  }

  // Handle download
  function onClickDownload(type = "pdf") {
    const link = document.createElement("a");
    link.href = type === "pdf" ? pdfUrl : latestBlob;
    
    // const currentTimestamp = new Date().toISOString();
    // console.log("currentTimestamp>>",currentTimestamp)
    // link.download = `file_${currentTimestamp}`;
    // console.info("link.download", link.download);
    // link.click();
    handleDownload(latestBlob);
  }

  const handleDownload = async (fileUrl) => {
    const fileName = pptName + ".pptx";
    console.info("fileUrl>>",fileUrl);
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed", error);
    }
  };

  // Change layout orientation
  function onChangeLayout(layout) {
    const prevSlides = [...slidesConfig];
    if (layout === "portrait") {
      if (prevSlides[activeSlide - 1].layout === "v4") {
        prevSlides[activeSlide - 1].layout = "v14";
      }
      if (prevSlides[activeSlide - 1].layout === "v9") {
        prevSlides[activeSlide - 1].layout = "v19";
      }
    } else {
      if (prevSlides[activeSlide - 1].layout === "v14") {
        prevSlides[activeSlide - 1].layout = "v4";
      }
      if (prevSlides[activeSlide - 1].layout === "v19") {
        prevSlides[activeSlide - 1].layout = "v9";
      }
    }
    setSlidesConfig(prevSlides);
    layoutGenerator(pptx, prevSlides,selectedFont?.value);
  }

  // UI handlers
  const handleTextButtonClick = () => {
    setPdfText("");
    setTextView(true);
  };

  const handleUploadButtonClick = () => setTextView(false);

  const handleGenerateSlides = async () => {
    setActiveSlide(1);
    setImageArray([]);
    setLatestBlob("");
    setPdfUrl("");
    setIsLoading("Analyzing your inputs using AI");

    try {
      const extractedData2 = await generateTextDataUsingLLM(pdfText);
      if (!extractedData2) {
        setIsLoading(false);
        toast.show({
          heading: "Failed to generate text data",
          position: "bottomRight",
          variant: "error",
        });
        return;
      }

      const result = extractedData2.map((item) => ({
        ...defaultSlideData,
        type: "text",
        layout: "v1",
        slideDataArray: [{ ...DEFAULT_TEXT_OBJECT, data: item }],
        title: "",
      }));

      result.unshift({
        ...defaultSlideData,
        type: "text",
        layout: "v0",
        slideDataArray: [{ ...DEFAULT_TEXT_OBJECT, data: [] }],
        title: pptName,
      });
      setSlidesConfig(result);
      layoutGenerator(pptx, result,selectedFont?.value);
    } catch (error) {
      console.error("Error generating text data:", error);
      setIsLoading(false);
    }
  };

  function onDragEnd(slidesConfig) {
    layoutGenerator(pptx, slidesConfig,selectedFont?.value);
  }

  function onClickEditSlide(e) {
    console.info("activeSlide ",activeSlide);

    if(activeSlide === 1){
      setIsEditFirstSlideOpen(true);
    }else{
      setIsEditSlideOpen(true);
    }
    // setIsEditSlideOpen(true);
    // setIsEditFirstSlideOpen(true);
  }
  function onEditGenericSlide(e){
    console.info("onEditGenericSlide",e);
    slidesConfig[activeSlide - 1] = e;
    layoutGenerator(pptx, slidesConfig,selectedFont?.value);
  }

  return (
    <div className="relative min-h-screen">
      {isLoading && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-[2px] z-50">
          <div className="absolute bottom-8 right-8 bg-gray-900 p-4 rounded-lg flex items-center gap-4 w-[420px] shadow-lg border border-gray-700">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-400"></div>
            <p className="text-lg font-medium text-gray-100">{isLoading}</p>
          </div>
        </div>
      )}

      {!isGenerated ? (
        <PPTInputUI
          pptName={pptName}
          setPptName={setPptName}
          textView={textView}
          handleTextButtonClick={handleTextButtonClick}
          handleUploadButtonClick={handleUploadButtonClick}
          pdfText={pdfText}
          setPdfText={setPdfText}
          setTextView={setTextView}
          templates={templates}
          selectedTemplate={selectedTemplate}
          handleSelectTemplate={handleSelectTemplate}
          isLoading={isLoading}
          handleGenerateSlides={handleGenerateSlides}
        />
      ) : (
        <div className="flex flex-col w-full">
          <div className="flex gap-2  py-2 px-6 justify-between">
            <div
              className="flex items-center  "
              onClick={() => {
                if (isLoading) return;
                setPdfText("");
                setPptName(" ");
                setIsGenerated(false);
              }}
            >
              <span className="flex items-center  cursor-pointer">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15.75 19.5L8.25 12l7.5-7.5"
                  />
                </svg>
              </span>
              <span className="p-2 cursor-pointer font-bold">
                {pptName ? pptName : "Go back"}
              </span>
            </div>

            <div className="flex gap-2">
              <div className="flex gap-2 mr-[250px]">
               <FontSelector
                  selectedFont={selectedFont}
                  setSelectedFont={setSelectedFont}
                  onFontChange={onFontChange}
                />
                <TemplateDropdown
                  selectedTemplate={selectedTemplate}
                  setSelectedTemplate={setSelectedTemplate}
                  onTemplateChange={onTemplateChange}
                />
              </div>

              {latestBlob && (
                <Button onClick={() => onClickDownload("ppt")}>
                  <RiDownload2Fill /> Download sx
                </Button>
              )}
            </div>
          </div>

          <main className="w-full p-2 flex border flex-col">
            <div className="flex gap-2 w-full">
              {latestBlob ? (
                <ImageViewer
                  imageArray={imageArray}
                  setImageArray={setImageArray}
                  activeSlide={activeSlide}
                  setActiveSlide={setActiveSlide}
                  slidesConfig={slidesConfig}
                  onDragEnd={onDragEnd}
                  setSlidesConfig={setSlidesConfig}
                  controls={
                    false ? (
                      <></>
                    ) : (
                      <SlideControlsTest
                        onAddChart={() => setIsInsertChartOpen(true)}
                        onAddTable={() => setIsInsertTableOpen(true)}
                        onAddImage={() => setIsInsertImageOpen(true)}
                        onMoveMedia={() => setIsMoveMediaOpen(true)}
                        onSummarize={() => {}}
                        MoveMedia={() => {}}
                        onAddSlide={onAddSlide}
                        onEditSlide={onClickEditSlide}
                        onChangeLayout={onChangeLayout}
                        isLoading={isLoading}
                        currentSlideIndex={activeSlide}
                        currentSlide={slidesConfig[activeSlide - 1]}
                      />
                    )
                  }
                />
              ) : (
                <p className="text-3xl text-gray-600 text-center py-10">
                  Select a slide to preview
                </p>
              )}
            </div>
          </main>
        </div>
      )}

      <InsertImage
        isOpen={isInsertImageOpen}
        setIsOpen={setIsInsertImageOpen}
        onInsertImage={onAddImage}
      />
      <InsertTable
        isOpen={isInsertTableOpen}
        setIsOpen={setIsInsertTableOpen}
        onInsertTable={onAddTable}
        activeSlide={slidesConfig[activeSlide - 1]}
        onReplaceTable={onReplaceTable}
      />
      <InsertChart
        isOpen={isInsertChartOpen}
        setIsOpen={setIsInsertChartOpen}
        onInsertChart={onAddChart}
        activeSlide={slidesConfig[activeSlide - 1]}
      />
      <MoveMedia
        isOpen={isMoveMediaOpen}
        setIsOpen={setIsMoveMediaOpen}
        slidesConfig={slidesConfig}
        onMoveMediaDone={onMoveMediaDone}
        activeSlide={activeSlide}
      />
      <EditSlide
        isOpen={isEditSlideOpen}
        setIsOpen={setIsEditSlideOpen}
        onEditSlide={() => {
          // setIsEditSlideOpen(false);
          if(activeSlide === 1){
            setIsEditFirstSlideOpen(true);
          }else{
            setIsEditSlideOpen(true);
          }
        }}
      />
      <EditFirstSlide
        isOpen={isEditFirstSlideOpen}
        setIsOpen={setIsEditFirstSlideOpen}
        activeSlideConfig={slidesConfig[activeSlide - 1]}
        onEditFirstSlide={(e)=>{
          console.info("Editing first slide",e,slidesConfig[0]);
          slidesConfig[0].title = e.title;
          console.info("slidesConfig >>>>",slidesConfig);
          layoutGenerator(pptx, slidesConfig,selectedFont?.value);
          setIsEditFirstSlideOpen(false);
        }}
      />
      <EditGenericSlide
        isOpen={isEditSlideOpen}
        setIsOpen={setIsEditSlideOpen}
        activeSlideConfig={slidesConfig[activeSlide - 1]}
        onEditSlide={onEditGenericSlide}
        activeSlideNumber={activeSlide}

      />
    </div>
  );
}

export default PPTGenerator;
